import { sessionStorageHelper } from './sessionStorage';

const STATE_STORAGE_KEY = 'authState';

/**
 * Generates a one-time `state` value, remembers it for this tab only and returns it
 * so it can be sent to the login endpoint, which has to echo it back with the token
 */
function createAuthState(): string {
  const state = crypto.randomUUID();

  sessionStorageHelper.setItem(STATE_STORAGE_KEY, state);

  return state;
}

/**
 * Checks the `state` echoed back by the login endpoint against the one this tab created.
 * The stored state is consumed either way, so every state can be used only once.
 */
function consumeAuthState(received: string | null): boolean {
  const expected = sessionStorageHelper.getItem(STATE_STORAGE_KEY);

  sessionStorageHelper.removeItem(STATE_STORAGE_KEY);

  return Boolean(expected && received && expected === received);
}

export { createAuthState, consumeAuthState };
